/* eslint-disable no-unused-vars */
import edelapConfig from './utilities/edelapConfig';
import edenConfig from './utilities/edenConfig';
import edesConfig from './utilities/edesConfig';
import edetConfig from './utilities/edetConfig';
import ejesaConfig from './utilities/ejesaConfig';
import utilitycoConfig from './utilities/utilitycoConfig';

export const EMAIL = 'email';
export const DOCUMENT = 'documentType';

const configMapper = {
  eden: edenConfig,
  edelap: edelapConfig,
  edes: edesConfig,
  edet: edetConfig,
  ejesa: ejesaConfig,
  utilityco: utilitycoConfig
};

export const appConfig = configMapper[process.env.REACT_APP_UTILITY_NAME];
